import Image from "../Image";

/**
 * 花瓣Logo
 * @param {{
 *  size?: number,
 *  width?: number,
 *  height?: number,
 *  hasText?: boolean,
 * }} props
 * @returns
 */
export default function HBLogo({
  size = 24,
  width,
  height,
  hasText = false,
  ...props
}) {
  const src = hasText
    ? "https://grocery-cdn.huaban.com/file/hb_logo_text.svg"
    : "https://grocery-cdn.huaban.com/file/hb_logo.svg";

  return (
    <Image
      src={src}
      alt="花瓣网"
      width={width || size}
      height={height || size}
      loading={"eager"}
      {...props}
    />
  );
}
